// DevHub: header nav dropdown (Admin / Docs jump-off menus). Extracted from
// Root.tsx. A ghost button that toggles a menu of NavItem links.
import { useTranslationRef } from '@backstage/core-plugin-api/alpha';
import { commonMessages } from '../../i18n/common';
import { useLink } from '../common';
import { useDropdown } from './useDropdown';
import { type NavItem } from './navConfig';

export function NavDropdown({
  label,
  items,
  isActive,
}: {
  label: string;
  items: NavItem[];
  isActive: boolean;
}) {
  const link = useLink();
  const { open, setOpen, ref } = useDropdown();
  const { t } = useTranslationRef(commonMessages);

  return (
    <div className="devhub-nav-dropdown" ref={ref}>
      {/* Use the <odx-button> web component (not the .odx-button CSS class) so the
          trigger renders identically to the plain nav items — same shadow control
          typography (14px / weight 500). The class form missed that and rendered
          off-size/weight. */}
      <odx-button
        /* `class`, not className: React 18 does not reflect className onto a custom
           element (it renders a literal `classname` attribute), so the .is-active
           highlight was dead on this dropdown while the plain nav buttons (which use
           `class`) worked. This is why the Documentation/Admin top-nav items never lit up. */
        class={isActive ? 'is-active' : undefined}
        variant="ghost"
        onClick={() => setOpen(o => !o)}
      >
        {label}
        <odx-icon className="odx-icon" name="core::chevron-down" size="sm" />
      </odx-button>
      {open && (
        <div className="devhub-nav-dropdown__menu">
          {items.map(item => {
            const l = link(item.path);
            return (
              <a
                key={item.path}
                className="devhub-nav-dropdown__item"
                href={l.href}
                onClick={e => {
                  l.onClick(e);
                  setOpen(false);
                }}
              >
                <odx-icon className="odx-icon" name={item.icon} size="sm" />
                {(t as unknown as (k: string) => string)(item.labelKey)}
              </a>
            );
          })}
        </div>
      )}
    </div>
  );
}
